export const TYPES = [
  { key: "men", label: "Meshkuj" },
  { key: "women", label: "Femra" },
];

export const CLOUDINARY = {
  cloudName: "dtzxt9pvc",
  uploadPreset: "properpizza_unsigned",
  folder: "products",
};
